import { RoutePath } from '@core/types/route';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { FC, memo, useCallback } from 'react';

import { SX_MENU_ITEM, SX_ROUTE } from '../utils/mobile-menu-item';

type MobileMenuItemProps = {
  href: RoutePath | string;
  onClick: (href: RoutePath | string) => void;
  text: string;
};

const MobileMenuItem: FC<MobileMenuItemProps> = ({ href, onClick, text }) => {
  const handleClick = useCallback((href: RoutePath | string) => onClick(href), [onClick]);

  return (
    <MenuItem disableRipple onClick={() => handleClick(href)} sx={SX_MENU_ITEM}>
      <Typography className='no-underline' component='a' sx={SX_ROUTE} variant='body2'>
        {text}
      </Typography>
    </MenuItem>
  );
};

export default memo(MobileMenuItem);
